import { postJSON } from '../utils/fetchUtils'

export function shareQuote(data) {
  return postJSON('/share/quote/', data)
}
